import { B2CPolicy, IEnvironmentVariables } from 'src/environments/IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_SignUp_SignIn',
    signUpSignInRegence: 'B2C_1A_SignUp_SignIn_Regence',
    signUpSignInportalextsso: 'B2C_1A_SignUp_SignIn_portalextsso',
    resetPassword: 'B2C_1A_PasswordReset',
  },
  authorityBaseUrl: 'https://mncportaldev.b2clogin.com/tfp/mncportaldev.onmicrosoft.com',
};

const BASE_URL = 'https://portaldev.mynexuscare.com/';

const API_URL = {
  Platform: 'https://api-platform.portaldev.mynexuscare.com',
  HH: 'https://api-homehealth.portaldev.mynexuscare.com',
  PAC: 'https://api-pacim.portaldev.mynexuscare.com',
  DMEPOS: 'https://api-dmepos.portaldev.mynexuscare.com',
  SDoH: 'https://api-sdoh.portaldev.mynexuscare.com',
  SP: 'https://api-specialtyprograms-gateway.portaldev.mynexuscare.com',
  DocumentGateway: 'https://api-document-gateway.portaldev.mynexuscare.com',
  NotificationGateway: 'https://api-notification-gateway.portaldev.mynexuscare.com',
};

const consentScopes = [
  'https://mncportaldev.onmicrosoft.com/api/api.Write',
  'https://mncportaldev.onmicrosoft.com/api/api.Read',
  'https://mncportaldev.onmicrosoft.com/api/user_impersonation',
];

export const environment: IEnvironmentVariables = {
  production: false,
  b2cPolicies: b2cPolicies,
  baseUrl: BASE_URL,
  appInsightsConnectionString: 'InstrumentationKey=2bb90f58-133a-450b-9ebd-5941a511bbd1;IngestionEndpoint=https://eastus-1.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=1163daa5-1de3-41f6-b636-33f0a913bc03',
  apiUrl: API_URL.HH,
  apiPlatformUrl: API_URL.Platform,
  apiDocumentUrl: API_URL.DocumentGateway,
  apiUrlPacIM: API_URL.PAC,
  apiDMEPOSUrl: API_URL.DMEPOS,
  apiSDoHUrl: API_URL.SDoH,
  apiSpecialtyProgramsUrl: API_URL.SP,
  apiNotificationsUrl: API_URL.NotificationGateway,
  routerUrl: 'https://resourcerouter.portaldev.mynexuscare.com',
  sdohUrl: 'https://sdoh.portaldev.mynexuscare.com/',
  codeManagementUrl: 'https://web-codemanagement.portaldev.mynexuscare.com/',
  extssoBaseUrl: 'https://extsso.portaldev.mynexuscare.com/',
  hhProviderFinderUrl : 'https://carelonsolutions--full.sandbox.my.salesforce-sites.com/ProviderFinder',
  authConfig: {
    config: {
      auth: {
        clientId: 'fe9425ee-f357-42b9-829f-ba2f5e4fc23c',
        postLogoutRedirectUri: BASE_URL,
        redirectUri: BASE_URL,
        knownAuthorities: ['mncportaldev.b2clogin.com'],
      },
      system: {},
    },
    angularConfig: {
      extraQueryParameters: {
        prompt: 'select_account',
      },
      consentScopes: [...consentScopes, 'openid', 'profile'],
      protectedResourceMap: [
        ...Object.values(API_URL).map((url) => [`${url}/*`, consentScopes]),
      ],
    },
  },
  registryUrl: `${API_URL.Platform}/api/app-registry`,
};
